import styled from "styled-components";

export const SelectsContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 20px;
  width: 700px;
`;
